var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "category" }, [
    _c("div", { staticClass: "banxin" }, [
      _c("div", { staticClass: "head", staticStyle: { display: "none" } }, [
        _c(
          "div",
          {
            staticClass: "all goHome",
            on: {
              click: function() {
                this$1.$router.push({ name: "index" })
              }
            }
          },
          [_vm._v("\n        首页\n      ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "arrow" }),
        _vm._v(" "),
        _c("div", { staticClass: "keyword" }, [
          _vm._v(_vm._s(_vm.classifyName))
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticStyle: { padding: "30px 0" } }, [
        _c("div", { staticClass: "category-banner-container" }, [
          _c("div", { staticClass: "fenleiTitle" }, [
            _c("div", { staticClass: "rootName" }, [
              _vm._v(_vm._s(_vm.rootName))
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "fenleiBtn" }, [_vm._v("收起筛选")])
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "category-container",
              staticStyle: { background: "#ffffff" }
            },
            [
              _c(
                "div",
                {
                  staticClass: "showClassify",
                  staticStyle: { padding: "20px", border: "1px solid #F5F5F5" }
                },
                [
                  _vm.categoryData.length > 1
                    ? _c(
                        "div",
                        _vm._l(_vm.categoryData, function(subItem, index) {
                          return _c(
                            "div",
                            { key: index, staticClass: "categoryData" },
                            [
                              index > 0
                                ? _c(
                                    "div",
                                    {
                                      key: subItem.id,
                                      staticClass: "twocategory",
                                      staticStyle: { cursor: "pointer" },
                                      on: {
                                        click: function($event) {
                                          $event.stopPropagation()
                                          return _vm.jumpCategory(
                                            Object.assign({}, subItem, {
                                              rootName: _vm.item.categoryName
                                            })
                                          )
                                        }
                                      }
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(subItem.categoryName) +
                                          "\n                "
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              index > 0
                                ? _c(
                                    "div",
                                    { staticClass: "threecategory" },
                                    _vm._l(subItem.childs, function(
                                      Item2,
                                      index
                                    ) {
                                      return _c(
                                        "span",
                                        {
                                          key: index,
                                          staticStyle: { cursor: "pointer" },
                                          on: {
                                            click: function($event) {
                                              $event.stopPropagation()
                                              return _vm.jumpCategory(
                                                Object.assign({}, Item2, {
                                                  rootName: Item2.categoryName
                                                })
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(Item2.categoryName)
                                          )
                                        ]
                                      )
                                    }),
                                    0
                                  )
                                : _vm._e()
                            ]
                          )
                        }),
                        0
                      )
                    : _c("div", [
                        _c("div", { staticClass: "categoryData" }, [
                          _c(
                            "div",
                            {
                              staticClass: "twocategory",
                              staticStyle: { cursor: "pointer" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.jumpCategory(
                                    Object.assign({}, _vm.categoryData, {
                                      rootName: _vm.categoryData.categoryName
                                    })
                                  )
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.categoryData.categoryName) +
                                  "\n                "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "threecategory" },
                            _vm._l(_vm.categoryData.childs, function(
                              Item2,
                              index
                            ) {
                              return _c(
                                "span",
                                {
                                  key: index,
                                  class:
                                    "" +
                                    (Item2.id == _vm.threeClassifyId
                                      ? _vm.activeSub
                                      : ""),
                                  staticStyle: { cursor: "pointer" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      return _vm.jumpCategory(
                                        Object.assign({}, Item2, {
                                          rootName: Item2.categoryName
                                        })
                                      )
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(Item2.categoryName)
                                  )
                                ]
                              )
                            }),
                            0
                          )
                        ])
                      ])
                ]
              )
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "filter-container" }, [
        _c("div", { staticClass: "sort" }, [
          _c(
            "div",
            {
              staticClass: "default",
              class: _vm.index == "1" ? "active" : "",
              on: {
                click: function($event) {
                  return _vm.defaultSort()
                }
              }
            },
            [_vm._v("\n          综合\n        ")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sales",
              class: _vm.index == "3" ? "active" : "",
              on: {
                click: function($event) {
                  return _vm.salesSort()
                }
              }
            },
            [
              _vm._v("\n          销量\n          "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.index !== "3",
                    expression: "index !== '3'"
                  }
                ],
                attrs: {
                  src: require("../../../../static/image/reduce@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.index == "3" && _vm.volume == 1,
                    expression: "index == '3' && volume == 1"
                  }
                ],
                attrs: {
                  src: require("../../../../static/image/reduce2@2x.png"),
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.index == "3" && _vm.volume == 2,
                    expression: "index == '3' && volume == 2"
                  }
                ],
                attrs: {
                  src: require("../../../../static/image/reduce1@2x.png"),
                  alt: ""
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "price",
              class: _vm.index == "2" ? "active" : "",
              on: {
                click: function($event) {
                  return _vm.priceSort()
                }
              }
            },
            [
              _vm._v("\n          价格\n          "),
              _c("div", { staticClass: "arr" }, [
                _c("div", {
                  staticClass: "up",
                  class: _vm.type == 1 ? "low" : ""
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "down",
                  class: _vm.type == 2 ? "high" : ""
                })
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.noProduct == true
        ? _c("div", { staticClass: "content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loading,
                    expression: "loading"
                  }
                ],
                staticClass: "proList"
              },
              [_vm._m(0)]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.noProduct == false
        ? _c(
            "div",
            { staticClass: "content content_yes" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading"
                    }
                  ],
                  staticClass: "proList"
                },
                [
                  _vm.noProduct == false
                    ? _c(
                        "div",
                        [
                          _c("ProductList", {
                            attrs: { productList: _vm.productList }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _vm.noProduct == false && _vm.total > 20
                ? _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.page,
                      "page-size": 20,
                      background: "",
                      layout: "prev, pager, next",
                      total: _vm.total
                    },
                    on: {
                      "update:currentPage": function($event) {
                        _vm.page = $event
                      },
                      "update:current-page": function($event) {
                        _vm.page = $event
                      },
                      "current-change": _vm.handleCurrentChange
                    }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "noproduct" }, [
      _c("img", {
        attrs: {
          src: require("../../../../static/image/noorder@2x.png"),
          alt: ""
        }
      }),
      _vm._v(" "),
      _c("p", { staticClass: "fs20 font-color-999" }, [
        _vm._v("该分类没有商品～")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-4f5a6652", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-4f5a6652","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/b2c/category/index.vue
// module id = null
// module chunks = 